import type { PostClientSignup } from '@lt/api/dist/methods/client/types';

export enum FormFields {
  Id = 'id',
  Name = 'name',
  Surname = 'surname',
  Email = 'email',
  Phone = 'phone',
  AcceptProcessingPersonalData = 'acceptProcessingPersonalData',
  AcceptPromotions = 'acceptPromotions',
}

export interface FormValues {
  [FormFields.Id]?: number | undefined;
  [FormFields.Name]?: string;
  [FormFields.Surname]?: string;
  [FormFields.Email]?: string;
  [FormFields.Phone]?: string;
  [FormFields.AcceptProcessingPersonalData]?: boolean;
  [FormFields.AcceptPromotions]?: boolean;
}

export type OnSubmit = (data: PostClientSignup) => Promise<void>;
